import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';

import { UppyFeatureFlagWrapper } from '@components/common/uppy/UppyFeatureFlagWrapper';
import { structureUppyAttachments } from '@helpers/uploaders';
import {
  uniqueFilesByKey,
  duplicateSweetAlertOptions,
  formattedUppyAttachments,
  getUniqueKey,
  sanitizeUppyKey,
} from '@helpers/uppy';

class AttachmentUppy extends React.Component {
  triggerClickHandlerRef = React.createRef();

  triggerUpload = (files) => {
    const uniqueKey = getUniqueKey();
    const uniqFiles = uniqueFilesByKey(files, uniqueKey);
    if (files.length !== uniqFiles.length) {
      window.swal(duplicateSweetAlertOptions, (removeDuplicates) => {
        if (removeDuplicates) {
          this.stageAttachmentForUpload(formattedUppyAttachments(uniqFiles));
        } else {
          this.stageAttachmentForUpload(formattedUppyAttachments(files));
        }
      });
    } else {
      this.stageAttachmentForUpload(structureUppyAttachments(files));
    }
  }

  stageAttachmentForUpload = (attachments) => {
    const { assetKey, onUpload } = this.props;

    onUpload(attachments);
    Insight.createEvent('added_attachments', assetKey, 'asset');
  }

  trigger = () => `uppy-asset-upload-trigger-${sanitizeUppyKey(this.props.assetKey)}`

  handleTriggerClick = (event) => {
    if (this.triggerClickHandlerRef.current) {
      this.triggerClickHandlerRef.current(event);
    }
  }

  renderArea() {
    return (
      <div className="uppy-attachment-area" id={this.trigger()} onClick={this.handleTriggerClick}>
        <p><Trans>Click to add an attachment</Trans></p>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyFeatureFlagWrapper
          {...this.props}
          button
          handleUpload={this.triggerUpload}
          trigger={`#${this.trigger()}`}
          onTriggerClickHandler={this.triggerClickHandlerRef}
          uniqIdentifier={`attachment-uppy-${sanitizeUppyKey(this.props.assetKey)}`}
        />
      </React.Fragment>
    );
  }
}

AttachmentUppy.propTypes = {
  assetKey: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired
};

export default AttachmentUppy;
